export default __webpack_public_path__ + "static/media/reactLogo.30b5dc77.svg";